
import logoutMixin from '@/mixins/logoutMixin'
import { ACCOUNT_MAIN_MENU } from '@/utils/accountMenu'

export default {
  name: 'UserAccountMenu',
  mixins: [logoutMixin],

  data() {
    return {
      menu_items_list: [
        { name: this.$t('components.userAccountMenu.dashboard'), to: 'compte' },
        {
          name: this.$t('components.userAccountMenu.myOrders'),
          to: 'compte-commandes',
        },
        {
          name: this.$t(
            'components.userAccountMenu.afterSalesServiceGuarantees'
          ),
          to: 'compte-service-client',
        },
        {
          name: this.$t('components.userAccountMenu.myReturns'),
          to: 'compte-retours-produits',
        },
        {
          name: this.$t('components.userAccountMenu.mySavedCarts'),
          to: 'compte-paniers-sauvegardes',
        },
        {
          name: this.$t('components.userAccountMenu.myAvailabilityAlerts'),
          to: 'compte-alertes-disponibilite',
        },
        {
          name: this.$t('components.userAccountMenu.myFavoriteProducts'),
          to: 'compte-favoris',
        },
        {
          name: this.$t('components.userAccountMenu.myRecentlyVisited'),
          to: 'compte-historique',
        },
        {
          name: this.$t('components.userAccountMenu.myAddresses'),
          to: 'compte-adresses',
        },
        {
          name: this.$t('components.userAccountMenu.myInformation'),
          to: 'compte-informations',
        },
        {
          name: this.$store.getters.is_pro_plus
            ? this.$t('components.userAccountMenu.myProPlusAccount')
            : this.$t('components.userAccountMenu.myProAccount'),
          to: 'compte-professionnel',
        },
        {
          name: this.$t('components.userAccountMenu.myAffiliation'),
          to: 'compte-affiliation',
        },
      ],
      isLoading: true,
      mobileMenuOpen: false,
      list_conversations: [],
      list_returns: [],
      pending_orders: 0,
      saved_carts: [],
      favorites: [],
    }
  },

  computed: {
    filteredMenuItems() {
      return this.menu_items_list.map(item => ({
        ...item,
        name:
          this.$t(`components.userAccountMenu.${item.to.replace(/-/g, '_')}`) ||
          this.$t(
            `components.userAccountMenu.${item.name
              .toLowerCase()
              .replace(/\s+/g, '_')
              .replace(/\//g, '')}`
          ) ||
          item.name,
      }))
    },
    mainMenuItems() {
      return ACCOUNT_MAIN_MENU.map(item => ({
        ...item,
        name: this.$t(item.label),
      }))
    },
    settingsMenuItems() {
      return [
        {
          name:
            this.$t('components.userAccountMenu.compte_adresses') ||
            'Mes adresses',
          to: 'compte-adresses',
          icon: ['fal', 'user-check'],
        },
        {
          name:
            this.$t('components.userAccountMenu.compte_informations') ||
            'Mes informations',
          to: 'compte-informations',
          icon: ['fal', 'pencil'],
        },
        {
          name: this.$store.getters.is_pro_plus
            ? this.$t('components.userAccountMenu.compte_professionnel_plus') ||
              'Mon compte PRO+'
            : this.$t('components.userAccountMenu.compte_professionnel') ||
              'Mon compte PRO',
          to: 'compte-professionnel',
          icon: ['fal', 'user-check'],
        },
        {
          name:
            this.$t('components.userAccountMenu.compte_affiliation') ||
            'Mon affiliation',
          to: 'compte-affiliation',
          icon: ['fal', 'plus'],
        },
      ]
    },
    affiliationNeedsAttention() {
      const affiliate = this.$auth.user?.affiliate
      if (!affiliate?.codes?.length) return false
      const commissions = affiliate.commissions || []
      if (commissions.length === 0) return true
      const dates = commissions.map(c => new Date(c.created_at))
      const latest = Math.max(...dates)
      const days = Math.floor((Date.now() - latest) / (1000 * 60 * 60 * 24))
      return days >= 30
    },
    proDocumentsMissing() {
      const company = this.$auth.user?.company

      return Boolean(
        company &&
          company.company_status?.identifier !== 'verified' &&
          company.uploads?.length === 0
      )
    },
    activeConversationCount() {
      return this.list_conversations.filter(
        conversation =>
          conversation.conversation_status && conversation.conversation_status.identifier === 'open'
      ).length
    },
    activeReturnCount() {
      return this.list_returns.filter(
        returnItem =>
          returnItem.order_return_status &&
          (returnItem.order_return_status.identifier === 'pending' ||
            returnItem.order_return_status.identifier === 'draft')
      ).length
    },
    pendingOrdersCount() {
      return this.pending_orders
    },
    savedCartsCount() {
      return this.saved_carts.length
    },
    alertsCount() {
      return this.$auth.user?.alerts?.length || 0
    },
    favoritesCount() {
      return this.favorites.length
    },
  },
  async mounted() {
    this.$nuxt.$on('account-menu:refresh', this.fetchNotifications)
    if (this.$auth.loggedIn) {
      await this.fetchNotifications()
    }
  },
  beforeDestroy() {
    this.$nuxt.$off('account-menu:refresh', this.fetchNotifications)
  },

  methods: {
    async fetchNotifications() {
      try {
        const { data: counts } = await this.$authService.fetchAccountMenuCounts()
        this.pending_orders = counts.pending_orders
        this.list_conversations = Array(counts.active_conversations).fill({
          conversation_status: { identifier: 'open' },
        })
        this.list_returns = Array(counts.active_returns).fill({
          order_return_status: { identifier: 'pending' },
        })
        this.saved_carts = Array(counts.saved_carts).fill({})

        // Récupérer les favoris
        try {
          const favorites = this.$store.state.favorites || []
          this.favorites = favorites
        } catch (e) {
          this.favorites = []
        }
      } catch (error) {
        console.error(
          'Erreur lors de la récupération des notifications:',
          error
        )
      }
    },
  },
}
